import { useState } from "react";

export default function useFetch(endPoint) {
  const baseUrl = process.env.REACT_APP_API_URL;

  const [isLoading, setIsLoading] = useState(true);

  async function get(endPoint) {
    try {
      setIsLoading(true);
      const response = await fetch(baseUrl + endPoint);
      const data = await response.json();

      if (!data) {
        throw new Error("No data received");
      }

      setIsLoading(false);
      return data;
    } catch (error) {
      setIsLoading(false);
      throw error;
    }
  }

  return { get, isLoading };
}
